import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthUtilsService } from '../../utils/auth-utils.service';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-redirect-onboarding',
  templateUrl: './redirect-onboarding.component.html',
  styleUrls: ['./redirect-onboarding.component.scss'],
})
export class RedirectOnboardingComponent implements OnInit, OnDestroy {
  actualYear: number = new Date().getFullYear();
  subscription: Subscription;
  constructor(
    public utils: AuthUtilsService,
    public authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.loggedUserObs.subscribe((user) => {
      if (user) {
        setTimeout(() => {
          this.authService.createUuid().subscribe((resp) => {
            window.location.href = environment.mantecaUrl + `auth/w-signup/id?code=${resp.code}`;
          });
        }, 5000);
      } else {
        this.router.navigate(['auth', 'signin']);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
